module.exports = require('./lib/tunnel');



//////////////////
// WEBPACK FOOTER
// ./~/tunnel/index.js
// module id = 1085
// module chunks = 0